import React from 'react';
import PropTypes from 'prop-types';

import './SearchResultsListEmpty.scss';

const SearchResultsError = ({ error }) => (
    <div className="SearchResultsListEmpty">
        <div className="error">{error}</div>
    </div>
);

SearchResultsError.propTypes = {
    error: PropTypes.string,
};

export default SearchResultsError;
